import { useState } from 'react';

import { useRiskRegisterStore } from 'store/riskRegister.store';

import { useQueryActivityLevelDrivers } from 'api/queries/activityLevelDrivers.query';

import { impactTypeOptions } from 'components/widgets/ActivityLevelDrivers/ActivityLevelDrivers.utils';

export type UseActivityLevelDriversProvider = ReturnType<typeof useActivityLevelDriversProvider>;

export const useActivityLevelDriversProvider = ({ latestVersionId, endpoint }) => {
    const { numOfIterations, riskIds, taskVersionHashCode, runQsra } = useRiskRegisterStore();
    const [impactType, setImpactType] = useState<ISelectOption<'DAYS' | 'CORRELATION'>>(impactTypeOptions[0]);

    return {
        ui: {
            state: {
                impactType,
            },
            setters: {
                setImpactType,
            },
        },
        api: {
            activityLevelDrivers: useQueryActivityLevelDrivers(
                {
                    riskIds,
                    taskVersionHashCode,
                    numOfIterations,
                    metaDataId: latestVersionId,
                    runQsra,
                },
                endpoint,
            ),
        },
    };
};
